import { Card, Spinner, Alert, Button } from "react-bootstrap";
import useSignFormPayload from "../form/hooks/useSignFormPayload";
import Signature from "../../../CommonComponents/Signature/Signature";

export default function PdfTemplateDisplay() {
    const {
        pdfUrl,
        handleSubmit,
        loadSignatures,
        payload,
        mergedPdfUrl,
        signedStudentIds,
        loadingMergedPdf,
        mergedPdfError,
    } = useSignFormPayload();

    const { template_id, batch_student_id, student_id } = payload;

    // Check if we should show single student PDF
    const shouldDisplaySinglePdf = template_id && batch_student_id && pdfUrl;

    // Check if we should show merged PDF (template selected but no specific student)
    const shouldDisplayMergedPdf =
        template_id && !batch_student_id && mergedPdfUrl;

    return (
        <Card className="">
            <Card.Body>
                {!template_id && <div>Please select PDF template</div>}

                {/* Single Student PDF View */}
                {shouldDisplaySinglePdf && (
                    <>
                        <div className="mb-3">
                            <h6>Individual Student PDF</h6>
                        </div>
                        <div className="pdf-viewer">
                            <embed
                                src={pdfUrl}
                                type="application/pdf"
                                width="100%"
                                height="600px"
                            />
                        </div>

                        <Signature
                            key={batch_student_id}
                            onSubmit={handleSubmit}
                            studentId={student_id}
                            loadingSignatures={loadSignatures}
                            additionalPayloadData={payload}
                        />
                    </>
                )}

                {/* Merged PDF View */}
                {template_id && !batch_student_id && (
                    <>
                        {loadingMergedPdf && (
                            <div className="text-center">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">
                                        Loading...
                                    </span>
                                </Spinner>
                                <p className="mt-2">
                                    Loading and merging signed PDFs...
                                </p>
                            </div>
                        )}

                        {mergedPdfError && (
                            <Alert variant="warning">{mergedPdfError}</Alert>
                        )}

                        {shouldDisplayMergedPdf && (
                            <>
                                <div className="mb-3">
                                    <Alert variant="info" className="p-2">
                                        Showing {signedStudentIds.length} merged
                                        signed document(s).
                                        <strong>
                                            Use the print button in the PDF
                                            viewer to print all pages.{" "}
                                        </strong>
                                    </Alert>
                                </div>
                                <div className="pdf-viewer">
                                    <embed
                                        src={mergedPdfUrl}
                                        type="application/pdf"
                                        width="100%"
                                        height="600px"
                                    />
                                </div>
                            </>
                        )}

                        {!loadingMergedPdf &&
                            !mergedPdfError &&
                            !mergedPdfUrl &&
                            signedStudentIds.length === 0 && (
                                <Alert variant="info">
                                    Select a student to view their individual
                                    PDF, or check the table below for signed
                                    documents.
                                </Alert>
                            )}
                    </>
                )}
            </Card.Body>
        </Card>
    );
}
